(() => {
  const callback = async () => {
    const getCartItems = async () => {
      try {
        const url = `${window.Shopify.routes.root}cart.js`;
        const request = await fetch(url);
        const data = await request.json();

        return data?.items ?? [];
      } catch (error) {
        console.error(error);
      }
    };

    const getSearchCriteria = async ({ productHandle }) => {
      if (!productHandle) return;

      try {
        const tagPairsJson = window?.themeComponents?.snippets?.['upsell-v2-ds']?.tagPairs;
        if (!tagPairsJson) return;

        const url = `${window.Shopify.routes.root}products/${productHandle}?view=upsell-product-json`;
        const request = await fetch(url);
        const data = await request.json();
        const { tags, material } = data ?? {};

        const searchCriteria = {
          styleTag: null,
          material: null,
          includedTags: [],
          excludedTags: [],
        };

        const styleTag = tags?.find((tag) => tag.includes('style-'));
        if (styleTag) searchCriteria.styleTag = styleTag;

        if (material) searchCriteria.material = material;

        const tagSelectors = {
          '+': searchCriteria.includedTags,
          '-': searchCriteria.excludedTags,
        };

        const tagPairs = JSON.parse(tagPairsJson).split(';').filter(Boolean);

        tagPairs.forEach((pair) => {
          const [targetTag, selectionRules] = pair.split(':');

          const hasTargetTag = targetTag && tags?.includes(targetTag);
          if (!hasTargetTag) return;

          const rules = selectionRules?.split(',') ?? [];
          rules.forEach((rule) => {
            const selector = rule.charAt(0);
            const tag = rule.slice(1);

            tagSelectors[selector]?.push(tag);
          });
        });

        return searchCriteria;
      } catch (error) {
        console.error(error);
      }
    };

    const mapSearchCriteriaToArguments = ({ searchCriteria }) => {
      const { styleTag, includedTags, excludedTags } = searchCriteria ?? {};

      const hasRequiredTags = styleTag && (!!includedTags?.length || !!excludedTags?.length);
      if (!hasRequiredTags) return;

      const style = `tag:'${styleTag}'`;
      const include = includedTags.map((tag) => `tag:'${tag}'`).join(' OR ');
      const exclude = excludedTags.map((tag) => `tag_not:'${tag}'`).join(' AND ');

      const groupTerms = (value) => `(${value})`;
      const arguments = [style, include, exclude].filter(Boolean).map(groupTerms).join(' AND ');

      return arguments;
    };

    const getSameSetProducts = async ({ queryArguments }) => {
      if (!queryArguments) return;

      try {
        const TOKEN = `6a687b6243d79bc49f32306634830cb5`;
        const url = `https://${window.Shopify.shop}/api/2024-04/graphql.json`;
        const query = `{
          products(first: 40, query: "${queryArguments}") {
            edges {
              node {
                handle
                tags
                material: metafield(namespace: "my_fields", key: "material") {
                  value
                }
              }
            }
          }
        }`;

        const request = await fetch(url, {
          async: true,
          crossDomain: true,
          method: 'POST',
          headers: {
            'X-Shopify-Storefront-Access-Token': TOKEN,
            'Content-Type': 'application/graphql',
          },
          body: query,
        });
        const data = await request.json();

        return data?.data?.products?.edges;
      } catch (error) {
        console.error(error);
      }
    };

    const mapProductsToArguments = ({ products }) => {
      if (!products) return;

      const productHandles = products.reduce((accumulator, current) => {
        const handle = current?.node?.handle;
        if (handle) accumulator.push('handle:' + handle);

        return accumulator;
      }, []);

      const arguments = productHandles.join(' OR ');

      return arguments;
    };

    const getUpsellContent = async ({ searchTemplate = 'upsell-cart', queryArguments }) => {
      if (!queryArguments) return;

      try {
        const url = `${window.Shopify.routes.root}search?view=${searchTemplate}&type=product&q=${queryArguments}`;
        const request = await fetch(url);
        const data = await request.text();

        return data;
      } catch (error) {
        console.error(error);
      }
    };

    const addToCart = async ({ variantId, addToCartBtn }) => {
      const payload = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      };

      try {
        const request = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (request.ok) {
          const data = await request.json();
          const product = data?.items?.[0];

          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: {
                product,
                addToCartBtn,
              },
            }),
          );
        }
      } catch (error) {
        console.error(error);
      }
    };

    const createToggles = ({ content }) => {
      const sets = content.querySelectorAll(selectors.setWrapper);
      if (!sets) return;

      if (sets.length > 1) {
        const toggles = document.createElement('span');
        toggles.className = selectors.toggles.slice(1);

        sets.forEach((set, index) => {
          const setToggle = document.createElement('button');

          setToggle.type = 'button';
          setToggle.className = selectors.toggle.slice(1);
          setToggle.classList.toggle('active', index === 0);
          setToggle.dataset.set = set.dataset.set ?? '';
          setToggle.dataset.index = set.dataset.index ?? '';
          setToggle.title = set.dataset.set.replace('style-', '');

          toggles.appendChild(setToggle);
        });

        return toggles;
      }
    };

    const updateSliders = ({ container }) => {
      const sliders = container.querySelectorAll(selectors.slider);

      sliders.forEach((slider) => {
        if (!slider.swiper) {
          new Swiper(slider, {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 20,
            loop: true,
            mousewheel: {
              forceToAxis: true,
            },
            navigation: {
              nextEl: slider.parentNode.querySelector(selectors.sliderButtonNext),
              prevEl: slider.parentNode.querySelector(selectors.sliderButtonPrev),
            },
          });
        }
      });
    };

    const updatePrice = ({ product, option }) => {
      if (!product || !option) return;

      const { priceRegular, priceCompare } = option.dataset;

      const priceRegularElement = product.querySelector(selectors.priceRegular);
      if (priceRegularElement) priceRegularElement.innerHTML = priceRegular || '';

      const priceCompareElement = product.querySelector(selectors.priceCompare);
      if (priceCompareElement) priceCompareElement.innerHTML = priceCompare || '';
    };

    const renderContent = ({ upsellBlock, contentContainer, content }) => {
      contentContainer.innerHTML = '';

      contentContainer.appendChild(content);

      const togglesContainer = upsellBlock.querySelector(selectors.togglesContainer);
      if (togglesContainer) {
        togglesContainer.innerHTML = '';

        const togglesContent = createToggles({ content });
        if (togglesContent) togglesContainer.appendChild(togglesContent);

        togglesContainer.parentNode.classList.toggle('hidden', !togglesContent);
      }

      // Pre-select size of the already added product
      const products = contentContainer.querySelectorAll(selectors.product);
      products.forEach((product) => {
        const set = product.closest(selectors.setWrapper);
        const preselectedSize = set?.dataset?.preselectedSize;
        if (!preselectedSize) return;

        product.querySelectorAll('option').forEach((option) => {
          const isPreselectedSizeAvailable = option.innerHTML === preselectedSize && !option.hasAttribute('disabled');

          if (isPreselectedSizeAvailable) {
            option.setAttribute('selected', '');
            updatePrice({ product, option });
          }
        });
      });
    };

    const createElementFromHtml = (htmlString) => {
      const div = document.createElement('div');
      div.innerHTML = htmlString;

      return div.firstElementChild;
    };

    const togglePreloader = ({ upsellBlock, show }) => {
      if (show) upsellBlock.classList.remove('hidden');
      upsellBlock.classList.toggle('processing', show);
    };

    const onQuantityChange = ({ upsellBlock, itemsContainer }) => {
      const { items, items_added: itemsAdded, items_removed: itemsRemoved } = event?.detail?.cart;

      // Force reload as fallback in case the Cart JSON no longer returns the required data on Shopify's end again
      if (!itemsAdded.length && !itemsRemoved.length) {
        initialize({ upsellBlock, itemsContainer });
      }

      if (!items || !itemsRemoved.length) return;

      // Reload data only if an item is fully removed from the cart
      const isDecreasingQuantity = !!itemsRemoved.length;
      const hasMoreQuantity = items.find((item) => item.id === itemsRemoved[0].variant_id);
      if (isDecreasingQuantity && !hasMoreQuantity) {
        initialize({ upsellBlock, itemsContainer });
      }
    };

    const initialize = async ({ upsellBlock, productHandle, searchTemplate }) => {
      const contentContainer = upsellBlock.querySelector(selectors.content);
      if (!contentContainer) return;

      togglePreloader({ upsellBlock, show: true });

      const targetProducts = productHandle ? [{ handle: productHandle }] : await getCartItems();

      const generatedContent = document.createElement('div');

      await Promise.all(
        targetProducts.map(async (item, index) => {
          // Skip discounted sets (Not sure if it's still needed, but left it for backward compatibility)
          const hasSetDiscount = item?.line_level_discount_allocations?.find(
            (discount) => discount?.discount_application?.title === 'Discount on set',
          );
          if (hasSetDiscount) return;

          // Skip items that are already in the set
          const cartItem = document.querySelector(`${selectors.cartItem}[data-key^="${item?.id}"]`);
          const isAlreadyInSet = cartItem?.closest(selectors.cartSet);
          if (isAlreadyInSet) return;

          const searchCriteria = await getSearchCriteria({ productHandle: item?.handle });
          const { styleTag, material } = searchCriteria ?? {};

          const sameSetProducts = await getSameSetProducts({
            queryArguments: mapSearchCriteriaToArguments({ searchCriteria }),
          });

          // Exclude products from other sets since Shopify returns products
          // not by exact tag match, but even by partial occurance (for example, for the Black set
          // it also returns products from the Black Crystal and Black Leopard sets)
          let filteredProducts = sameSetProducts?.filter((product) => product?.node?.tags?.includes(styleTag));

          // Exclude products made of different materials if product has specified material
          const sameMaterialProducts = filteredProducts?.filter(
            (product) => product?.node?.material?.value === JSON.stringify(material),
          );

          if (!window.Shopify.designMode) {
            filteredProducts = sameMaterialProducts;
          }

          const upsellContent = await getUpsellContent({
            queryArguments: mapProductsToArguments({ products: filteredProducts }),
            searchTemplate,
          });
          if (!upsellContent) return;

          const set = createElementFromHtml(upsellContent);
          set.classList.add('hidden');
          set.dataset.index = index;
          set.dataset.preselectedSize = item?.options_with_values?.[0]?.value ?? '';

          // Highlight excluded products and the reason for exclusion in the theme editor
          if (window.Shopify.designMode) {
            const excludedProducts = filteredProducts.filter((product) => !sameMaterialProducts.includes(product));

            excludedProducts.forEach((product) => {
              const productItem = set.querySelector(`${selectors.product}[data-product-handle="${product.node.handle}"]`);
              if (productItem) {
                const productMaterial = JSON.parse(product.node.material?.value ?? '[]').toString();
                const content = (locale.productIsExcluded ?? '')
                  .replace(/&quot;/g, '"')
                  .replace('[material]', productMaterial)
                  .replace('[material]', material);

                productItem.setAttribute('data-before', content);
                productItem.classList.add('excluded');
              }
            });
          }

          generatedContent.appendChild(set);
        }),
      );

      const isContentEmpty = generatedContent.children.length < 1;
      upsellBlock.classList.toggle('hidden', isContentEmpty);
      if (isContentEmpty) return;

      // Remove duplicates with the same style name
      for (const set of generatedContent.children) {
        const styleName = set.dataset.set;
        const sameSets = generatedContent.querySelectorAll(`${selectors.setWrapper} [data-set='${styleName}']`);

        if (sameSets.length > 1) set.remove();
      }

      const firstSet = generatedContent.firstElementChild;
      if (firstSet) firstSet.classList.remove('hidden');

      renderContent({ upsellBlock, contentContainer, content: generatedContent });
      updateSliders({ container: contentContainer });
      togglePreloader({ upsellBlock, show: false });
    };

    // Initialization
    const selectors = {
      upsell: '.upsell',
      content: '.upsell__content',
      toggles: '.upsell__toggles',
      toggle: '.upsell__toggle',
      title: '.upsell__title',
      cartSet: '#CartDrawer .cart-set',
      cartItem: '#CartDrawer .cart__item',
      setWrapper: '[data-upsell-selector="set-wrapper"]',
      togglesContainer: '[data-upsell-selector="toggles-container"]',
      slider: '[data-upsell-selector="slider"]',
      sliderButtonPrev: '[data-upsell-selector="slider-button-prev"]',
      sliderButtonNext: '[data-upsell-selector="slider-button-next"]',
      product: '[data-upsell-selector="product"]',
      priceRegular: '[data-upsell-selector="price-regular"]',
      priceCompare: '[data-upsell-selector="price-compare"]',
      sizeSelector: '[data-upsell-selector="size-selector"]',
      addToCart: '[data-upsell-selector="add-to-cart"]',
    };

    const { locale } = window.themeComponents.snippets['upsell-v2-ds'] ?? {};

    const upsellBlocks = document.querySelectorAll(selectors.upsell);
    upsellBlocks.forEach((upsellBlock) => {
      const { searchTemplate, productHandle } = upsellBlock.dataset;

      const acceptedTemplates = ['upsell-cart', 'upsell-pdp'];
      if (!acceptedTemplates.includes(searchTemplate)) {
        upsellBlock.remove();
        return;
      }

      const isCollapsable = upsellBlock.classList.contains('collapsable');
      if (isCollapsable) {
        const isCollapsed = sessionStorage.getItem('isUpsellCollapsed') === 'true';
        upsellBlock.classList.toggle('collapsed', isCollapsed);
      }

      if (productHandle) {
        initialize({ upsellBlock, productHandle, searchTemplate });
      } else {
        document.addEventListener('cart:markup-built', () => initialize({ upsellBlock }), {
          once: true,
        });
        document.addEventListener('cart:product-added', () => initialize({ upsellBlock }));
        document.addEventListener('cart:product-removed', () => initialize({ upsellBlock }));
        document.addEventListener('cart:updated', () => onQuantityChange({ upsellBlock }));
      }

      // Event handlers
      upsellBlock.addEventListener('click', (event) => {
        const { target } = event;

        if (target.closest(selectors.title)) {
          if (!isCollapsable) return;

          upsellBlock.classList.toggle('collapsed');

          const isCollapsed = upsellBlock.classList.contains('collapsed');
          sessionStorage.setItem('isUpsellCollapsed', isCollapsed);
        }

        if (target.matches(selectors.toggle)) {
          upsellBlock.querySelectorAll(selectors.setWrapper).forEach((set) => {
            const toggles = upsellBlock.querySelectorAll(selectors.toggle);
            toggles.forEach((toggle) => toggle.classList.toggle('active', target === toggle));

            const isRelevantSet =
              target.dataset?.set === set.dataset?.set && target.dataset?.index === set.dataset?.index;
            set.classList.toggle('hidden', !isRelevantSet);
          });
        }

        if (target.matches(selectors.addToCart)) {
          const product = target.closest(selectors.product);
          const sizeSelector = product?.querySelector(selectors.sizeSelector);
          const variantId = sizeSelector?.value;
          if (!variantId) return;

          document.dispatchEvent(new CustomEvent('cart:preloader-triggered'));
          addToCart({ variantId, addToCartBtn: target });
        }
      });

      upsellBlock.addEventListener('change', (event) => {
        const { target } = event;

        if (target.matches(selectors.sizeSelector)) {
          const product = target.closest(selectors.product);
          const option = target.querySelector(`option[value="${target.value}"]`);
          if (!product || !option) return;

          updatePrice({ product, option });
        }
      });
    });
  };

  window.addEventListener('DOMContentLoaded', callback);
})();
